 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A781847675095_COVER from '@/components/9781847675095_cover'
 import LOVE_1 from '@/components/love_1'
 import A781847675095_BOOKTITLEPAGE from '@/components/9781847675095_booktitlepage'
 import A781847675095_INTRODUCTION from '@/components/9781847675095_introduction'
 import A781847675095_TOC from '@/components/9781847675095_toc'
 import A781847675095_CHAPTER_01 from '@/components/9781847675095_chapter_01'
 import A781847675095_CHAPTER_02 from '@/components/9781847675095_chapter_02'
 import A781847675095_CHAPTER_03 from '@/components/9781847675095_chapter_03'
 import A781847675095_CHAPTER_04 from '@/components/9781847675095_chapter_04'
 import A781847675095_CHAPTER_05 from '@/components/9781847675095_chapter_05'
 import A781847675095_CHAPTER_06 from '@/components/9781847675095_chapter_06'
 import A781847675095_CHAPTER_07 from '@/components/9781847675095_chapter_07'
 import A781847675095_CHAPTER_08 from '@/components/9781847675095_chapter_08'
 import A781847675095_CHAPTER_09 from '@/components/9781847675095_chapter_09'
 import A781847675095_CHAPTER_10 from '@/components/9781847675095_chapter_10'
 import A781847675095_CHAPTER_11 from '@/components/9781847675095_chapter_11'
 import A781847675095_CHAPTER_12 from '@/components/9781847675095_chapter_12'
 import A781847675095_CHAPTER_13 from '@/components/9781847675095_chapter_13'
 import A781847675095_CHAPTER_14 from '@/components/9781847675095_chapter_14'
 import A781847675095_CHAPTER_15 from '@/components/9781847675095_chapter_15'
 import A781847675095_CHAPTER_16 from '@/components/9781847675095_chapter_16'
 import A781847675095_CHAPTER_17 from '@/components/9781847675095_chapter_17'
 import A781847675095_CHAPTER_18 from '@/components/9781847675095_chapter_18'
 import A781847675095_CHAPTER_19 from '@/components/9781847675095_chapter_19'
 import A781847675095_CHAPTER_20 from '@/components/9781847675095_chapter_20'
 import A781847675095_CHAPTER_21 from '@/components/9781847675095_chapter_21'
 import LOVE_2 from '@/components/love_2'
 import A781847675095_ABOUTTHEAUTHOR from '@/components/9781847675095_abouttheauthor'
 import A781847675095_INSERTEDCOPYRIGHT from '@/components/9781847675095_insertedcopyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/9781847675095_toc",
 			"name" : "9781847675095_toc",
 			"component" : A781847675095_TOC
 		},
 		{
 			"path" : "/9781847675095_chapter_01",
 			"name" : "9781847675095_chapter_01",
 			"component" : A781847675095_CHAPTER_01
 		},
 		{
 			"path" : "/9781847675095_chapter_02",
 			"name" : "9781847675095_chapter_02",
 			"component" : A781847675095_CHAPTER_02
 		},
 		{
 			"path" : "/9781847675095_chapter_03",
 			"name" : "9781847675095_chapter_03",
 			"component" : A781847675095_CHAPTER_03
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js